export enum LocalEnum {
  zhCN = 'zh-CN',
  enUS = 'en-US',
}

export enum AmountEnum {
  CNY = 'CNY',
  USD = 'USD',
}

export enum UserRole {
  Admin = 1,
  User = 2,
}

// 项目类型
export enum ProjectType {
  // 常规项目 ddp
  Regular = 1,
  // 国内MM
  DomesticMM = 2,
  // 国外MM
  OverseasMM = 3,
}

export enum OrderStatus {
  Total = 0,
  WaitingForShip = 1,
  InTransit = 2,
  Delivered = 3,
  Canceled = 4,
  InProduction = 5,
  ReadyToShip = 6,
  BookedAVessel = 7,
  InlandDelivery = 8,
  // 异常订单
  Exception = 9,
}

// 周期账单确认状态
export enum PeriodBillConfirmStatus {
  // 未定义
  Undefined = 0,
  // 待确认
  PendingConfirm = 1,
  // 部分确认
  PartialConfirm = 2,
  // 已完成
  Confirmed = 3,
}

// 周期账单支付状态
export enum PeriodBillPayStatus {
  // 未定义
  Undefined = 0,
  // 待支付
  PendingPayment = 1,
  // 部分支付
  PartialPayment = 2,
  // 已支付
  Paid = 3,
}
